import { useCallback, useEffect, useState } from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { FormattedReactionItem } from 'features/room-reactions/utils/ReactionsDisplayManager';
import { useReactionsDisplayManager } from 'features/room-reactions/hooks/useReactionsDisplayManager';

export type UseReactionsDisplayResult = {
  items: readonly FormattedReactionItem[];
  containerRef: ReturnType<typeof useResizeDetector>['ref'];
  containerHeight: number;
  removeItem: (id: string) => void;
};

export const useReactionsDisplay = (): UseReactionsDisplayResult => {
  const {
    height: containerHeight,
    width: containerWidth,
    ref: containerRef,
  } = useResizeDetector({
    handleHeight: true,
    handleWidth: true,
    refreshMode: 'debounce',
    refreshRate: 16,
  });

  const manager = useReactionsDisplayManager();

  const [items, setItems] = useState<readonly FormattedReactionItem[]>([]);

  useEffect(() => manager.subscribe(setItems), [manager]);

  useEffect(() => {
    manager.setContainerWidth(containerWidth ?? 0);
  }, [manager, containerWidth]);

  const removeItem = useCallback((id: string) => manager.removeItem(id), [manager]);

  return {
    items,
    containerRef,
    containerHeight: containerHeight ?? 0,
    removeItem,
  };
};
